import { render } from "./Navigation.vue?vue&type=template&id=01b5df2c"
const script = {}
script.render = render

export default script